import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/data";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-primary text-primary-foreground relative overflow-hidden px-6">
      <div className="grain absolute inset-0" />
      <div className="relative w-full max-w-md border border-primary-foreground/20 bg-primary/60 backdrop-blur-xl p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO} alt="IPNOMICS" className="h-11 w-11 object-contain bg-white p-1" />
          <span className="font-display text-2xl">IPNOMICS Admin</span>
        </div>
        <p className="overline text-accent mb-8 flex items-center gap-2"><Lock size={14} /> Secure Access</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-primary-foreground/60 block mb-2">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-primary-foreground/10 border-b-2 border-transparent focus:border-accent px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/40 outline-none transition-colors" placeholder="enquiry@ipnomics.in" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-primary-foreground/60 block mb-2">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-primary-foreground/10 border-b-2 border-transparent focus:border-accent px-4 py-3 text-primary-foreground placeholder:text-primary-foreground/40 outline-none transition-colors" placeholder="••••••••" />
          </div>
          <button data-testid="admin-login-btn" type="submit" disabled={loading}
            className="w-full bg-accent text-white py-4 text-xs font-medium tracking-[0.18em] uppercase hover:bg-white hover:text-primary transition-colors duration-300 flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
